<template>
  <basic-container>
    <avue-crud
        :data="data"
        :option="option"
        :table-loading="loading"
        @current-change="currentChange"
        @on-load="onLoad"
        @refresh-change="refreshChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        ref="crud"
        v-model="form">
      <template slot="menu" slot-scope="scope">
        <el-button
            @click.stop="handleClaim(scope.row)"
            class="none-border"
            size="small"
            type="text"
            v-if="permission.work_claim_sign">签收
        </el-button>
        <el-button
            @click.stop="handleDetail(scope.row)"
            class="none-border"
            size="small"
            type="text"
            v-if="permission.work_claim_detail">详情
        </el-button>
        <el-button
            @click.stop="handleImage(scope.row,scope.index)"
            class="none-border"
            size="small"
            type="text"
            v-if="permission.work_claim_follow">跟踪
        </el-button>
      </template>
      <template
          slot="processDefinitionVersion"
          slot-scope="{row}">
        <el-tag>v{{ row.processDefinitionVersion }}</el-tag>
      </template>
    </avue-crud>
    <el-dialog
        :fullscreen="true"
        :visible.sync="flowBox"
        append-to-body
        title="流程图">
      <iframe
          :src=flowUrl
          allowTransparency="yes"
          border="0"
          frameBorder="no"
          height="700"
          marginHeight="0"
          marginWidth="0"
          scrolling="no"
          title="流程图"
          width="100%">
      </iframe>
      <span
          class="dialog-footer"
          slot="footer">
        <el-button @click="flowBox = false">关 闭</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { claimList, claimTask } from '@/api/work/work'
import { flowCategory } from '@/util/flow'
import { flowUrl } from '@/config'

export default {
  data () {
    return {
      form: {},
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      flowBox: false,
      flowUrl: '',
      workBox: false,
      option: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        dialogWidth: 900,
        menuWidth: 150,
        dialogClickModal: false,
        column: [
          {
            label: '流程分类',
            type: 'select',
            row: true,
            dicUrl: '/sys/dict/code/flow',
            dataType: 'number',
            slot: true,
            prop: 'category',
            search: true,
            searchValue: 1,
            hide: true,
            width: 100
          },
          {
            label: '流程名称',
            prop: 'processDefinitionName',
            search: true
          },
          {
            label: '当前步骤',
            prop: 'taskName'
          },
          {
            label: '流程版本',
            prop: 'processDefinitionVersion',
            slot: true,
            width: 80
          },
          {
            label: '申请时间',
            prop: 'createTime',
            width: 165
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission', 'flowRoutes']),
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    searchReset () {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    selectionClear () {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    handleClaim (row) {
      this.$confirm('确定签收此任务?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        claimTask(row.taskId).then(res => {
          this.onLoad(this.page)
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        })
      })
    },
    handleDetail (row) {
      this.$router.push({ path: `/work/process/${row.processDefinitionKey}/detail/${row.taskId}/${row.processInstanceId}/${row.businessId}` })
    },
    handleImage (row) {
      this.flowUrl = `${flowUrl}${row.processInstanceId}&v=` + new Date().getTime()
      this.flowBox = true
    },
    currentChange (currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange () {
      this.onLoad(this.page, this.query)
    },
    onLoad (page, params = {}) {
      const query = {
        ...this.query,
        category: (params.category) ? flowCategory(params.category) : null
      }
      this.loading = true
      claimList(page.currentPage, page.pageSize, Object.assign(params, query)).then(res => {
        const data = res.data
        this.page.total = data.total
        this.data = data.records
        this.loading = false
        this.selectionClear()
      })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
